<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="py-0"
      >
        <v-text-field
          v-model="local.title"
          :label="$t('eDocInternal.subject')"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="py-0"
      >
        <v-text-field
          v-model="local.watchProps.docNo"
          :label="$t('Outbox.OficioNo')"
        />
        <v-btn
          small
          class="mr-1 mt-n2"
          @click="generateRefDocNo"
        >
          {{ $t('Outbox.AutoGenOficioNo') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-checkbox
      v-model="local.watchProps.isReply"
      :label="$t('Outbox.ReplyOficio')"
    />
    <v-row
      v-for="i in outboxReplyDocCnt"
      v-show="local.watchProps.isReply"
      :key="i"
    >
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="py-0"
      >
        <v-text-field
          v-model="local.watchProps.senderOficioNo[i-1]"
          :label="$t('Outbox.FromOficioNo')"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="py-0"
      >
        <s-date-picker
          v-model="local.watchProps.sendDate[i-1]"
          :clearable="true"
          :label="$t('Outbox.FromOficioDate')"
        />
      </v-col>
    </v-row>
    <br>
    <h3>
      {{ $t('Outbox.Oficio') }}
    </h3>
    <s-file-uploader-with-entity
      ref="oficioUploader"
      :post-url="uploadFileWordUrl"
      extensions="doc,docx"
      accept=".doc,.docx"
      :maximum="1"
      :filename.sync="oficioFilename"
      :response.sync="local.watchProps.oficioDocResponse"
      :label="$t('Outbox.UploadOficio')"
      @uploadError="onUploadError"
    />
    <ul class="text-caption grey--text">
      <li>{{ $t('Outbox.Upload.AllowFileType') }}: doc, docx</li>
    </ul>

    <br>
    <h3>
      {{ $t('Outbox.Combine') }}
    </h3>
    <s-file-uploader-with-entity
      ref="combineUploader"
      :post-url="uploadFileUrl"
      extensions="pdf"
      accept=".pdf"
      :maximum="10"
      :response.sync="local.watchProps.mergePdfResponse"
      :label="$t('Outbox.UploadCombineFile')"
      @uploadError="onUploadError"
    />
    <ul class="text-caption grey--text">
      <li>{{ $t('Outbox.Upload.AllowFileType') }}: pdf</li>
    </ul>

    <br>

    <!-- 非加密附件 -->
    <template v-if="!value.isEncryptDoc">
      <h3>{{ $t('Outbox.Attachment') }}</h3>
      <s-file-uploader-with-entity
        ref="attachUploader"
        multiple
        select-entity
        :entities="entities"
        :post-url="uploadFileUrl"
        extensions=""
        accept=""
        :response.sync="local.attachResponse"
        :label="$t('Outbox.UploadAttachment')"
        @uploadError="onUploadError"
      />
    </template>

    <!-- 加密附件 -->
    <template v-else>
      <h3>
        <!-- 加密附件 -->
        {{ $t('encrypt.encryptedAttachment') }}
        <v-icon
          color="primary"
        >
          {{ mdiLockOutline }}
        </v-icon>
      </h3>
      <s-file-uploader-with-entity-encrypted
        ref="attachUploader"
        multiple
        select-entity
        :entities="entities"
        :post-url="encryptedUploadFileUrl"
        extensions=""
        accept=""
        :response.sync="local.attachResponse"
        :label="$t('Outbox.UploadAttachment')"
        :file-password="local.filePassword"
        @uploadError="onUploadError"
      />
    </template>

    <br>

    <v-btn
      v-if="true"
      depressed
      @click="isShowMore = !isShowMore"
    >
      {{ $t('Outbox.More') }}
      <v-icon>{{ mdiMenuDown }}</v-icon>
    </v-btn>

    <div
      v-show="isShowMore"
      style="border: 5px solid #f5f5f5"
      class="pa-4"
    >
      <h3>{{ $t('Outbox.InterpellationReplyDoc') }}</h3>
      <s-file-uploader-with-entity
        ref="interpellationUploader"
        multiple
        :post-url="uploadFileWordUrl"
        extensions="doc,docx"
        accept=".doc,.docx"
        :response.sync="local.watchProps.interpellationDocResponse"
        :label="$t('Outbox.UploadInterpellationReplyDoc')"
        @uploadError="onUploadError"
      />

      <br><br>

      <h3>{{ $t('Outbox.RefDoc') }}（{{ $t('Outbox.WontSendWithOficio') }}）</h3>
      <s-file-uploader-with-entity
        ref="refUploader"
        multiple
        :post-url="uploadFileUrl"
        extensions=""
        accept=""
        :response.sync="local.refResponse"
        :label="$t('Outbox.UploadRefDoc')"
        @uploadError="onUploadError"
      />
    </div>

    <s-confirm-dialog
      v-model="isShowGenDocNoDialog"
      :message="$t('Outbox.Confirm.GenDocNo')"
      @confirm="confirmGenDoc"
    />
  </div>
</template>

<script>
import SDatePicker from '@/components/SDatePicker'
import SFileUploaderWithEntity from '@/components/SFileUploaderWithEntity'
import SFileUploaderWithEntityEncrypted from '@/components/SFileUploaderWithEntityEncrypted.vue'
import datetimeUtil from '@/utils/datetimeUtil'
import { filename } from '@/utils/stringUtil'
import outboxApi from '@/api/outbox/outbox'
import { globalModule } from '@/store/moduleName'
import SConfirmDialog from '@/components/SConfirmDialog'
import { uploadMethod } from '@/mixins/uploadMethod'
import { OUTBOX_REPLY_DOC_CNT } from '@/constant/constant'
import { mdiMenuDown, mdiLockOutline } from '@mdi/js'
import { isArrayEmptyOrNull } from '@/utils/arrayUtil'

export default {
  components: {
    SDatePicker,
    SFileUploaderWithEntity,
    SFileUploaderWithEntityEncrypted,
    SConfirmDialog
  },
  mixins: [uploadMethod],
  props: {
    value: {
      type: Object,
      default: null
    },
    entities: {
      type: Array,
      default: null
    },
    today: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      oficioFilename: '',
      isShowGenDocNoDialog: false,
      isShowMore: false,
      mdiMenuDown,
      mdiLockOutline
    }
  },
  computed: {
    local () {
      return this.value ? this.value : {
        watchProps: {
          docNo: null
        },
        title: null
      }
    },
    docTypesId () {
      return this.value.docTypesId
    },
    outboxReplyDocCnt () {
      return OUTBOX_REPLY_DOC_CNT
    },
    uploadFileWordUrl () {
      if (this.value.issueEntityId) {
        return this.$config.apiDomain.ALI + `/ext/ga/core-util-outbox/outbox/api/uploadWordFile?entityId=${this.value.issueEntityId}&entitySourceTypeId=1` // entitySourceTypeId hard code request by Allen
      } else {
        return this.$config.apiDomain.ALI + '/ext/ga/core-util-outbox/outbox/api/uploadWordFile'
      }
    },

    uploadFileUrl () {
      if (this.value.issueEntityId) {
        return this.$config.apiDomain.ALI + `/ext/ga/core-util-outbox/outbox/api/uploadFile?entityId=${this.value.issueEntityId}&entitySourceTypeId=1` // entitySourceTypeId hard code request by Allen
      } else {
        return this.$config.apiDomain.ALI + '/ext/ga/core-util-outbox/outbox/api/uploadFile'
      }
    },

    encryptedUploadFileUrl () {
      if (this.value.issueEntityId) {
        return this.$config.apiDomain.ALI + `/ext/ga/core-util-outbox/outbox/api/uploadFile?entityId=${this.value.issueEntityId}&entitySourceTypeId=1&isEncrypted=true` // entitySourceTypeId hard code request by Allen
      } else {
        return this.$config.apiDomain.ALI + '/ext/ga/core-util-outbox/outbox/api/uploadFile?isEncrypted=true'
      }
    }
  },
  watch: {
    oficioFilename: function (val) {
      if (!this.local.title) {
        this.local.title = filename(val)
      }
    },
    'value.issueEntityId': function (val) {
      this.clearFile()
    },
    'value.isEncryptDoc': function (val) {
      if (!isArrayEmptyOrNull(this.local.attachResponse)) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('outbox.attachementCleared'))
        this.$refs.attachUploader.clearFile()
        this.local.attachResponse = []
      }
    }
  },
  created () {
  },
  methods: {
    confirmGenDoc () {
      let annual = datetimeUtil.getYear(this.today)
      let oficioTypeId = this.value.docTypesId
      let title = this.value.title
      outboxApi.generateRefDocNo(annual, oficioTypeId, title, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.value.watchProps.docNo = resp.data
        }
      })
    },
    clearFile () {
      this.oficioFilename = ''
      this.$refs.oficioUploader.clearFile()
      this.local.watchProps.oficioDocResponse = []
      this.$refs.combineUploader.clearFile()
      this.local.watchProps.mergePdfResponse = []
      this.$refs.attachUploader.clearFile()
      this.local.attachResponse = []
      this.$refs.interpellationUploader.clearFile()
      this.local.watchProps.interpellationDocResponse = []
      this.$refs.refUploader.clearFile()
      this.local.refResponse = []
    },
    setFile (oficioFile, combineFile, attachFile, refFile, signAttachFile) {
      this.$refs.oficioUploader.setFile(oficioFile)
      this.$refs.combineUploader.setFile(combineFile)
      this.$refs.attachUploader.setFile(attachFile)
      this.$refs.refUploader.setFile(refFile)
      this.$refs.interpellationUploader.setFile(signAttachFile)
      if (!isArrayEmptyOrNull(refFile) || !isArrayEmptyOrNull(signAttachFile)) {
        this.isShowMore = true
      }
    },
    generateRefDocNo () {
      if (!this.value.title) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eDocInternal.subject')]))
        return false
      }
      this.isShowGenDocNoDialog = true
    }
  }
}
</script>
